/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createBeneficiary = /* GraphQL */ `
    mutation CreateBeneficiary($input: CreateBeneficiaryInput!) {
        createBeneficiary(input: $input) {
            success
            beneficiary {
                CompanyId
                BeneficiaryId
                ReferenceId
                BeneficiaryName
                BeneficiaryFirstName
                BeneficiaryLastName
                BankAccountHolderName
                AccountNumber
                BankCode
                BankCodeType
                BankCodeValue
                CompanyName
                EntityType
                PaymentType
                BankCountry
                BeneficiaryCountry
                Country
                Currency
                BankInfo
                Email
                BICSWIFT
                IBAN
                Address
                City
                State
                PostCode
                Timestamp
                Active
                Created
                Updated
                XeroPreferredAccountCode
                PayIdType
            }
            messages
        }
    }
`;

export const updateBeneficiary = /* GraphQL */ `
    mutation UpdateBeneficiary($input: UpdateBeneficiaryInput!) {
        updateBeneficiary(input: $input) {
            BeneficiaryId
            ReferenceId
            BeneficiaryName
            Created
            Updated
            PayIdType
        }
    }
`;
export const deleteBeneficiary = /* GraphQL */ `
    mutation DeleteBeneficiary($input: DeleteBeneficiaryInput!) {
        deleteBeneficiary(input: $input) {
            CompanyId
            BeneficiaryId
        }
    }
`;
